<template>
  <header class="header-container">
    <div class="background-video">
      <img :src="bgImage" width="100%" alt="" />
    </div>
    <div class="video-overlay"></div>
    <div class="header-content">
      <div class="content-wrapper">
        <div class="cover-left">
          <h1 class="cover-title" v-html="displayTitle"></h1>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'DynamicHeader',
  props: {
    title: { type: String, default: '' },
    image: { type: String, default: '' }
  },
  computed: {
    bgImage() {
      return this.image || require('../../assets/test.jpg');
    },
    displayTitle() {
      return this.title.replace(/\n/g, '<br />');
    }
  }
}
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }
.header-container { position: relative; width: 100%; height: 100vh; min-height: 600px; overflow: hidden; display: flex; align-items: center; justify-content: center; }
.background-video { position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; }
.background-video img { width: 100%; height: 100%; object-fit: cover; }
.video-overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: linear-gradient(135deg, rgba(192, 33, 48, 0.6) 0%, rgba(247, 240, 43, 0.3) 100%); z-index: 2; }
.header-content { position: relative; z-index: 3; width: 100%; height: 100%; display: flex; align-items: flex-end; justify-content: center; padding: 40px 20px; }
.content-wrapper { max-width: 800px; animation: fadeInUp 1s ease-out; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }
.cover-left { max-width: 55%; color: white; text-shadow: 0 6px 20px rgba(0,0,0,0.6); }
.cover-title { font-size: 84px; line-height: 0.95; margin: 0; font-weight: 900; letter-spacing: -2px; }
@media (max-width: 768px) { .header-content { align-items: flex-end; justify-content: flex-start; } .cover-left { max-width: 100%; } .cover-title { font-size: 48px; line-height: 1.1; } }
@media (max-width: 480px) { .header-content { padding: 20px; } .cover-title { font-size: 36px; line-height: 1.15; } }
</style>
